export const EXCLUDED_KEYS = new Set([
  'zip',
  'state',
  'city',
  'street',
  'org_uuid',
  'dealIds',
  'deals',
  'source',
  'contractedBy',
  'creation_timestamp',
  'monthlyAggregatedMetrics',
  'aggregatedMetrics',
  'name',
  'Paid Search - Media Spend',
  'Display Management Fee',
  'Paid Social Management Fee',
  'Website Hosting + 30 Minutes of Maintenance',
  'monthlySeo',
  'Projected Budget',
  'Expedited Launch',
  'Website Hosting',
])
